import { createSlice } from "@reduxjs/toolkit";
import { getCmmInputDataForOrder } from "../../../api/bigQuery/nycbsPharmaOrders";
import { mapToCoverMyMedsInputModel } from "../../../data-model/cmmInputRequestModel";
import { NycbsPharmaOrderModel } from "../../../data-model/nycbsPharmaOrder";
import { AppDispatch } from "../../store/store";

interface CmmSingleOrderModel {
  data?: NycbsPharmaOrderModel;
  loading: boolean;
  error: string | null;
}

const initialState: CmmSingleOrderModel = {
  data: undefined,
  loading: false,
  error: null,
};

const cmmSingleOrderSlice = createSlice({
  name: "cmmSingleOrderSlice",
  initialState,
  reducers: {
    fetchCmmSingleOrderStart(state) {
      state.loading = true;
      state.error = null;
      state.data = undefined;
    },
    fetchCmmSingleOrderSuccess(state, action) {
      state.data = action.payload;
      state.loading = false;
    },
    fetchCmmSingleOrderFailure(state, action) {
      state.error = action.payload;
      state.loading = false;
    },
    resetCmmSingleOrder(state) {
      state.data = undefined;
      state.loading = false;
      state.error = null;
    },
  },
});

export const { resetCmmSingleOrder } = cmmSingleOrderSlice.actions;

export const fetchSingleOrderDetailsForCmm =
  (orderId: string) => async (dispatch: AppDispatch, getState) => {
    const { cmmSingleOrder } = getState();
    if (cmmSingleOrder.loading) return;

    dispatch(cmmSingleOrderSlice.actions.fetchCmmSingleOrderStart());
    try {
      const results = await getCmmInputDataForOrder(orderId);

      const ordersData = results["details"];
      dispatch(
        cmmSingleOrderSlice.actions.fetchCmmSingleOrderSuccess(
          mapToCoverMyMedsInputModel(ordersData),
        ),
      );
    } catch (error) {
      dispatch(
        cmmSingleOrderSlice.actions.fetchCmmSingleOrderFailure(
          "Error fetching orders",
        ),
      );
    }
  };

export const updateCmmSingleOrder =
  (data: NycbsPharmaOrderModel) => async (dispatch: AppDispatch, getState) => {
    const { cmmSingleOrder } = getState();
    if (cmmSingleOrder.loading) return;

    const updatedData = mapToCoverMyMedsInputModel(data);

    dispatch(
      cmmSingleOrderSlice.actions.fetchCmmSingleOrderSuccess(updatedData),
    );
  };

export const resetSingleOrderData = () => async (dispatch: AppDispatch) => {
  dispatch(cmmSingleOrderSlice.actions.resetCmmSingleOrder());
};

export default cmmSingleOrderSlice.reducer;
